import React, { ReactNode } from "react";
import { cn } from "../../../lib/utils"; // optional if you use className merge utility

interface StickyBarProps {
  children: ReactNode;
  className?: string;   // for outer wrapper (positioning, margin, etc.)
  contentClassName?: string; // for inner container (styling like bg, border, shadow)
}

export const StickyBar: React.FC<StickyBarProps> = ({
  children,
  className,
  contentClassName,
}) => {
  return (
    <div
      className={cn(
        "fixed -translate-x-1/2 z-50 rounded-[8px]",
        className
      )}
    >
      <div
        className={cn(
          "inline-flex text-sm items-center gap-4 rounded-[8px] border border-[rgba(248,247,247,0.05)] bg-slate-900 shadow-lg px-3 py-2",
          contentClassName
        )}
        style={{
          boxShadow:
            "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)",
        }}
      >
        {children}
      </div>
    </div>
  );
};
